/**
 * node_modules
 */
import { useStaticQuery, graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"

/**
 * styles
 */
import * as styles from "@features/Home/CampSection/CampSection.module.scss"

/**
 * components
 */
import { Button } from "@components/Button"
import { ResponsiveImage } from "@components/ResponsiveImage"

/**
 * @function CampSection
 * @description HOME/CampSectionセクション
 */
export const CampSection = () => {
  /**
   * query
   */
  const data: Queries.HomeCampSectionDataQuery = useStaticQuery(graphql`
    query HomeCampSectionData {
      tsunanMobile: file(relativePath: { eq: "images/home/camp-tsunan.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      tsunanDesktop: file(relativePath: { eq: "images/home/camp-tsunan-desktop.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      tsumagoiMobile: file(relativePath: { eq: "images/home/camp-tsumagoi.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      tsumagoiDesktop: file(relativePath: { eq: "images/home/camp-tsumagoi-desktop.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      minaminorikuraMobile: file(relativePath: { eq: "images/home/camp-minaminorikura.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      minaminorikuraDesktop: file(
        relativePath: { eq: "images/home/camp-minaminorikura-desktop.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      allDataJson {
        nodes {
          home {
            campSection {
              id
              area
              url
              textWhite
              header {
                heading
                subHeading
                text
              }
              detail {
                heading1
                heading2
                table {
                  lowerColumn {
                    text
                  }
                  upperColumn {
                    text
                  }
                }
                text
              }
              button {
                text
                ariaLabel
              }
            }
          }
        }
      }
    }
  `)
  const jsonData = data.allDataJson.nodes
    .filter((item) => item.home !== null)
    .map((item) => item.home)
    .find((home) => home !== null)

  return (
    <article className={styles["campSection"]}>
      {jsonData!.campSection!.map((item) => (
        <section key={item!.id} className={styles["campSection_item"]}>
          <div className={`${styles["campSection_inner"]} ${styles["inner__sp"]}`}>
            <div className={styles["campSection_heading"]}>
              <h2>
                {item!.header!.subHeading ? (
                  <span className={styles["small"]}>{item!.header!.subHeading}</span>
                ) : null}
                <span>{item!.header!.heading}</span>
              </h2>
              <p className={styles["campSection_lead"]}>{item!.header!.text}</p>
            </div>
            <div className={styles["campSection_image"]}>
              {item!.area === "tsunan" && (
                <ResponsiveImage
                  mobileImage={getImage(data.tsunanMobile!.childImageSharp!.gatsbyImageData)}
                  desktopImage={getImage(data.tsunanDesktop!.childImageSharp!.gatsbyImageData)}
                />
              )}
              {item!.area === "tsumagoi" && (
                <ResponsiveImage
                  mobileImage={getImage(data.tsumagoiMobile!.childImageSharp!.gatsbyImageData)}
                  desktopImage={getImage(data.tsumagoiDesktop!.childImageSharp!.gatsbyImageData)}
                />
              )}
              {item!.area === "minaminorikura" && (
                <ResponsiveImage
                  mobileImage={getImage(
                    data.minaminorikuraMobile!.childImageSharp!.gatsbyImageData,
                  )}
                  desktopImage={getImage(
                    data.minaminorikuraDesktop!.childImageSharp!.gatsbyImageData,
                  )}
                />
              )}
              <h3
                className={`${styles["caption"]} ${item!.textWhite ? `${styles["caption__white"]}` : ""}`}
              >
                <span>{item!.detail!.heading1}</span>
                <span>{item!.detail!.heading2}</span>
              </h3>
            </div>

            <div className={styles["campSection_text"]}>
              <div className={styles["campSection_detail"]}>
                <h3>
                  <span>
                    {item!.detail!.heading1}
                    {item!.detail!.heading2}
                  </span>
                </h3>
                <p>{item!.detail!.text}</p>
                <table>
                  <tbody>
                    <tr>
                      {item!.detail!.table!.upperColumn!.map((item, index: number) => (
                        <td key={index}>{item!.text}</td>
                      ))}
                    </tr>
                    <tr>
                      {item!.detail!.table!.lowerColumn!.map((item, index: number) => (
                        <td key={index}>{item!.text}</td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className={styles["campSection_button"]}>
                <Button
                  text={item!.button!.text!}
                  to={item!.url!}
                  ariaLabel={item!.button!.ariaLabel!}
                  className={styles["campSection_button_link"]}
                />
              </div>
            </div>
          </div>
        </section>
      ))}
    </article>
  )
}
